export let mockContato = {
  id: null,
  purpose: null,
  name: 'contact',
  value: null,
  active: true
}
